import {
    GET_REPORTS_REQUEST,
    GET_REPORTS_SUCCESS,
    GET_REPORTS_FAILED
} from '../../actions/message/get-reports'

import { READ_MESSAGE_SUCCESS } from '../../actions/message/read-message'

const initialState = {
    reports: [],
    requesting: false,
    error: null,
    reportsTotal: 0
}

export const reports = (state = initialState, action) => {
    switch (action.type) {
        case GET_REPORTS_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                reports: [],
                error: null
            })
        case GET_REPORTS_SUCCESS:
            return Object.assign({}, state, {
                reports: Object.values(action.payload.data.payload.orderedMessages),
                requesting: false,
                error: action.error,
                reportsTotal: action.payload.data.payload.total
            })
        case GET_REPORTS_FAILED:
            return Object.assign({}, state, {
                reports: [],
                requesting: false,
                error: null
            })
        case READ_MESSAGE_SUCCESS:
            return Object.assign({}, state, {
                reports: state.reports.map((thread) => {
                    return Object.assign({}, thread, {
                        messages: thread.messages.map((message) => {
                            if (-1 !== action.messageIds.indexOf(message.id)) {
                                return Object.assign({}, message, { read: true })
                            }
                            return message
                        })
                    })
                })
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/report/reports.js